import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import AssignmentIcon  from "@mui/icons-material/Assignment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LogoutIcon      from "@mui/icons-material/Logout";
import EmailIcon       from "@mui/icons-material/Email";
import BusinessIcon    from "@mui/icons-material/Business";
import SettingsIcon    from "@mui/icons-material/Settings";

import { peticionGet } from "Componentes/ComponenteAxios";

const NAV_ITEMS = [
  { to: "/ListSurveys", icon: <AssignmentIcon  style={{ fontSize: 20 }} />, label: "Encuestas"         },
  { to: "/Templates",   icon: <ContentCopyIcon style={{ fontSize: 20 }} />, label: "Plantillas"         },
  { to: "/EmailLogs",   icon: <EmailIcon       style={{ fontSize: 20 }} />, label: "Moderación envíos"  },
];

const BarraNavegacion = ({ titulo, onLogout }) => {
  const navigate = useNavigate();

  const [user, setUser]         = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    peticionGet("/settings").then(({ peticion, error }) => {
      if (!error) setUser(peticion);
    });
  }, []);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const initials =
    user?.company_name?.charAt(0)?.toUpperCase() ||
    user?.user_name?.charAt(0)?.toUpperCase()    ||
    "U";

  const allItems = [
    ...NAV_ITEMS,
    ...(user?.user_id === 1
      ? [{ to: "/Companies", icon: <BusinessIcon style={{ fontSize: 20 }} />, label: "Empresas" }]
      : []),
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,600&family=DM+Sans:wght@400;500&display=swap');

        .enc-nav-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 8px;
          border: none;
          background: transparent;
          color: rgba(255,255,255,0.7);
          cursor: pointer;
          transition: background 0.15s ease, color 0.15s ease;
          text-decoration: none;
          flex-shrink: 0;
        }
        .enc-nav-btn:hover {
          background: rgba(255,255,255,0.12);
          color: #ffffff;
        }
        .enc-nav-btn.active {
          background: rgba(255,255,255,0.15);
          color: #ffffff;
        }
        .enc-avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: 2px solid rgba(255,255,255,0.3);
          cursor: pointer;
          transition: border-color 0.15s ease, transform 0.15s ease;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255,255,255,0.15);
          color: #ffffff;
          font-size: 13px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .enc-avatar:hover {
          border-color: rgba(255,255,255,0.7);
          transform: scale(1.05);
        }
        .enc-mobile-menu {
          position: absolute;
          top: 100%;
          right: 0;
          background: #0C447C;
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 0 0 12px 12px;
          padding: 8px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 180px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.2);
          z-index: 1000;
        }
        .enc-mobile-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          border-radius: 8px;
          color: rgba(255,255,255,0.85);
          font-family: 'DM Sans', system-ui, sans-serif;
          font-size: 14px;
          text-decoration: none;
          border: none;
          background: transparent;
          cursor: pointer;
          width: 100%;
          text-align: left;
          transition: background 0.12s ease;
        }
        .enc-mobile-item:hover {
          background: rgba(255,255,255,0.1);
          color: #ffffff;
        }
      `}</style>

      <nav style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: "linear-gradient(135deg, #0C447C 0%, #185FA5 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 2px 12px rgba(12,68,124,0.25)",
        fontFamily: "'DM Sans', system-ui, -apple-system, sans-serif",
      }}>
        <div style={{
          maxWidth: "1300px",
          margin: "0 auto",
          padding: "0 20px",
          height: "56px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}>

          {/* Logo / Título */}
          <div
            onClick={() => navigate("/")}
            style={{
              flex: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              minWidth: 0,
            }}
          >
            <div style={{
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              <AssignmentIcon style={{ fontSize: 16, color: "#ffffff" }} />
            </div>

            <span style={{
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: "500",
              color: "#ffffff",
              letterSpacing: "-0.2px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {isMobile ? "Surveys" : titulo || "Surveys.cloudlsf.es"}
            </span>
          </div>

          {/* Desktop nav */}
          {!isMobile && (
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              {allItems.map(item => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="enc-nav-btn"
                  title={item.label}
                >
                  {item.icon}
                </Link>
              ))}
            </div>
          )}

          {/* Separador */}
          {!isMobile && (
            <div style={{ width: "1px", height: "24px", background: "rgba(255,255,255,0.15)", margin: "0 6px" }} />
          )}

          {/* Avatar → Settings */}
          <div
            className="enc-avatar"
            onClick={() => navigate("/settings")}
            title={user?.company_name || user?.user_name || "Ajustes"}
          >
            {user?.company_logo_url ? (
              <img
                src={user.company_logo_url}
                alt="logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : initials}
          </div>

          {/* Logout */}
          <button
            className="enc-nav-btn"
            onClick={onLogout}
            title="Cerrar sesión"
          >
            <LogoutIcon style={{ fontSize: 20 }} />
          </button>

          {/* Mobile: menú hamburguesa */}
          {isMobile && (
            <div style={{ position: "relative" }}>
              <button
                className="enc-nav-btn"
                onClick={() => setMenuOpen(o => !o)}
                title="Menú"
                style={{ width: "36px", height: "36px" }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
                  <span style={{ width: "16px", height: "2px", background: "currentColor", borderRadius: "2px", transition: "all 0.2s", transform: menuOpen ? "rotate(45deg) translateY(6px)" : "none" }} />
                  <span style={{ width: "16px", height: "2px", background: "currentColor", borderRadius: "2px", transition: "all 0.2s", opacity: menuOpen ? 0 : 1 }} />
                  <span style={{ width: "16px", height: "2px", background: "currentColor", borderRadius: "2px", transition: "all 0.2s", transform: menuOpen ? "rotate(-45deg) translateY(-6px)" : "none" }} />
                </div>
              </button>

              {menuOpen && (
                <>
                  {/* Overlay para cerrar */}
                  <div
                    onClick={() => setMenuOpen(false)}
                    style={{ position: "fixed", inset: 0, zIndex: 999 }}
                  />
                  <div className="enc-mobile-menu">
                    {allItems.map(item => (
                      <Link
                        key={item.to}
                        to={item.to}
                        className="enc-mobile-item"
                        onClick={() => setMenuOpen(false)}
                      >
                        {item.icon}
                        {item.label}
                      </Link>
                    ))}
                    <div style={{ height: "1px", background: "rgba(255,255,255,0.1)", margin: "4px 0" }} />
                    <button
                      className="enc-mobile-item"
                      onClick={() => { setMenuOpen(false); navigate("/settings"); }}
                    >
                      <SettingsIcon style={{ fontSize: 20 }} />
                      Ajustes
                    </button>
                    <button
                      className="enc-mobile-item"
                      onClick={() => { setMenuOpen(false); onLogout(); }}
                    >
                      <LogoutIcon style={{ fontSize: 20 }} />
                      Cerrar sesión
                    </button>
                  </div>
                </>
              )}
            </div>
          )}

        </div>
      </nav>
    </>
  );
};

export default BarraNavegacion;
